import React from 'react';

import OutsideWallModel from './OutsideWallModel';
import InsideWallModel from './InsideWallModel';
import TrimModel from './TrimModel';

const FrontWall = () => {

    return (
        <>
            <OutsideWallModel />
            <InsideWallModel />
            <TrimModel />
        </>
    )
}

export default FrontWall